import { createContext, use } from "react";
import type { DataSource } from "@estelle/domain";

/**
 * The one data source the application talks to.
 *
 * Screens call `useDataSource()` and get the interface, never an
 * implementation. Swapping the fixture adapter for the real API adapter is a
 * different value passed to the provider — no screen changes, which is the
 * entire reason the interface exists.
 */
/*
  There is deliberately no default. A default would have to be an
  implementation, and the only one that can be built without being told where
  the API is, is the fixture adapter — which a build with `VITE_API_URL` set
  must not contain (#163). So a component rendered outside the provider gets
  an error from `useDataSource()`, not sample data it mistakes for real ones.
  `DataSourceProvider` decides between the real adapter and fixtures — one
  place, so the two cannot disagree.
*/
export const DataSourceContext = createContext<DataSource | null>(null);

export function useDataSource(): DataSource {
  const source = use(DataSourceContext);
  if (!source) {
    throw new Error("useDataSource used outside DataSourceProvider");
  }
  return source;
}
